import { createSlice } from "@reduxjs/toolkit";

const selectSpaceSlice = createSlice({
    name: "selectSpace",
    initialState: {
        selectSpace: '',
    },
    reducers: {
        setSpaceId: (state, action) => {
            state.selectSpace = action.payload;
        },
        clearSpace: (state) => {
            state.selectSpace = ''; // Reset the selected color
        },
    },
});

export const { setSpaceId , clearSpace } = selectSpaceSlice.actions;
export default selectSpaceSlice.reducer;
